'use client'

import { setCookie } from 'cookies-next'
import { type JSX, useEffect } from 'react'
import timestring from 'timestring'

interface Props {
  cookies: Record<string, string>
}

const CookieSetter = ({ cookies }: Props): JSX.Element => {
  useEffect(() => {
    Object.entries(cookies).forEach(([name, value]) => {
      setCookie(name, value, { maxAge: timestring('1 year', 'seconds') })
    })
  }, [cookies])
  return <></>
}

export default CookieSetter
